import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';

@Injectable()
export class Configuration {

}
function createUrl(actionName: string): string {
  return `${environment.apiHost}/${actionName}`;
}
function createAuthUrl(actionName: string): string {
  return `${environment.apiHost}/${actionName}`;
}

export const appApiResources = {
  baseUrl: environment.apiHost,
  getContactInfo: createUrl('partnerssearch'),
  getAmbassadorInfo: createUrl('ambass'),
  getSelectedContactInfo: createUrl('partners'),
  getOfferingType: createUrl('offeringtypes/general'),
  getEvent: createUrl('eventslist'),
  getEventPayment: createUrl('offering_types/event'),
  getBank: createUrl('banklist/general'),
  getDraweeBank: createUrl('banklist/drawee'),


  /**
   * Receipts API
   */
  aadReceipt: createUrl('addreceipt'),
  genReceiptDetails: createUrl('printreceipts'),
  getAllReceipt: createUrl('listreceipts'),
  getModeAndMedium: createUrl('modeandmedium/'),
  receiptReport: createUrl('reports'),
  letterContent: createUrl('letter'),

  /**
   * contact API
   */
  getTitle: createUrl('dropdown/title'),
  getLanguage: createUrl('dropdown/language'),
  getEducation: createUrl('dropdown/education'),
  getState: createUrl('dropdown/state'),
  getCountry: createUrl('dropdown/country'),
  pinCodeToGetDetails: createUrl('pincode/'),
  // contactList: createUrl('getpartners'),
  contactList: createUrl('getpartners1'),
  duplicatePartner: createUrl('duplicate_partner'),

  /**
   * Search List API
   */
  getEventList: createUrl('dropdown/events'),
  getEventCount: createUrl('contactcount'),
  getEventPrintLabel: createUrl('printlabels'),
  getContactCategory: createUrl('dropdown/roles'),
  postEventPrintLabel: createUrl('printlabels'),
  receiptSearch: createUrl('receipts'),
  getMode: createUrl('modeandmedium/mode'),
  offeringTypeEventBased: createUrl('offeringtypes/event'),

  /**
   * Magazine API
   */
  addMagazine: createUrl('addmagazinesub'),
  getUserMagazine: createUrl('getmagazinesubscribers'),
  updateMagazine: createUrl('updatemagazinesub'),
  deleteMagazine: createUrl('unsubmagazine'),

  /**
   * AUTH API
   */
  login: createUrl('authenticate'),

  /**
   * Donation API
   */
  getByPartnerID: createUrl('contact1'),
  onlineOffering: createUrl('onlineoffering'),
  addDonate: createUrl('contact'),
  getDonationList: createUrl('onlineoffreqs'),
  getDonationReceiptStyle: createUrl('printreceipt'),
  getOfferingStatus: createUrl('dropdown/offeringstatus'),
  verifyDonation: createUrl('verifydownloadreceipt'),
  downloadDonation: createUrl('downloadaddress'),

  /**
   * Event API
   */
  getEventRegisteredList: createUrl('eventsreglist'),
  getEventStatus: createUrl('dropdown/eventstatus'),
  updateEventStatus: createUrl('updateeventreg'),
  generateCallLetter: createUrl('calletter'),
  getAllCountry: createUrl('worldata'),
  createNewPartnerIDNew: createUrl('newcontact'),
  updatePartnerId: createUrl('updatepartner'),
};


export const buildVariable = {
  checkNewBuild: true
}